"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelect = void 0;
const react_1 = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const monera_app_core_2 = require("@amzn/monera-app-core");
const BLACK = '#111';
const ORANGE = '#e77600';
const GRAY = '#a2a6ac';
const GRAY_GRADIENT = 'linear-gradient(to bottom,#f7f8fa,#e7e9ec)';
const SHADOW_ORANGE = 'rgba(228,121,17,.5)';
const WHITE = '#f7f7f7';
const parseCustomStyles = (props) => {
    return {
        control: (styles, { isFocused }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            return (Object.assign(Object.assign({}, styles), { background: (_a = props.controlBackground) !== null && _a !== void 0 ? _a : GRAY_GRADIENT, border: (_b = props.controlBorder) !== null && _b !== void 0 ? _b : '1px solid lightgray', borderColor: isFocused ? (_c = props.controlBorderColor) !== null && _c !== void 0 ? _c : ORANGE : 'lightgray', '&:hover': {
                    borderColor: (_d = props.controlBorderColorHover) !== null && _d !== void 0 ? _d : GRAY
                }, boxShadow: isFocused ? (_e = props.controlBoxShadow) !== null && _e !== void 0 ? _e : `0 0 3px 2px ${SHADOW_ORANGE}` : 'none', cursor: (_f = props.controlCursor) !== null && _f !== void 0 ? _f : 'pointer', fontFamily: (_g = props.controlFontFamily) !== null && _g !== void 0 ? _g : (_j = (_h = monera_app_core_2.coreTheme.typography) === null || _h === void 0 ? void 0 : _h.base) === null || _j === void 0 ? void 0 : _j.fontFamily, fontSize: (_k = props.controlFontSize) !== null && _k !== void 0 ? _k : (_m = (_l = monera_app_core_2.coreTheme.typography) === null || _l === void 0 ? void 0 : _l.base) === null || _m === void 0 ? void 0 : _m.fontSize, height: (_o = props.controlHeight) !== null && _o !== void 0 ? _o : '48px', outline: (_p = props.controlOutline) !== null && _p !== void 0 ? _p : '0', overflow: (_q = props.controlOverflow) !== null && _q !== void 0 ? _q : 'visible', padding: (_r = props.controlPadding) !== null && _r !== void 0 ? _r : '0px', width: (_s = props.controlWidth) !== null && _s !== void 0 ? _s : '210px' }));
        },
        option: (styles, { isFocused, isSelected }) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return (Object.assign(Object.assign({}, styles), { backgroundColor: isFocused ? (_a = props.optionBackgroundColor) !== null && _a !== void 0 ? _a : WHITE : null, borderLeft: isSelected ? (_b = props.optionBorderLeft) !== null && _b !== void 0 ? _b : '2px solid orange' : null, color: (_c = props.optionColor) !== null && _c !== void 0 ? _c : BLACK, cursor: isFocused ? (_d = props.optionCursor) !== null && _d !== void 0 ? _d : 'pointer' : null, fontFamily: (_e = props.optionFontFamily) !== null && _e !== void 0 ? _e : (_g = (_f = monera_app_core_2.coreTheme.typography) === null || _f === void 0 ? void 0 : _f.base) === null || _g === void 0 ? void 0 : _g.fontFamily, fontSize: (_h = props.optionFontSize) !== null && _h !== void 0 ? _h : (_k = (_j = monera_app_core_2.coreTheme.typography) === null || _j === void 0 ? void 0 : _j.base) === null || _k === void 0 ? void 0 : _k.fontSize, fontWeight: isSelected ? (_l = props.optionFontWeight) !== null && _l !== void 0 ? _l : 'bold' : 'normal', padding: (_m = props.optionPadding) !== null && _m !== void 0 ? _m : '10px' }));
        }
    };
};
const CustomControl = (props) => {
    const onMouseDownHandler = props.innerProps.onMouseDown;
    return (react_1.default.createElement(react_select_1.components.Control, Object.assign({}, props, { innerProps: {
            onMouseDown: (e) => {
                e.preventDefault();
                onMouseDownHandler(e);
            }
        } })));
};
const CustomIndicator = (props) => {
    return react_1.default.createElement(react_select_1.components.DropdownIndicator, Object.assign({}, props, { innerProps: { onMouseDown: (e) => e.preventDefault() } }));
};
const CustomOption = (props) => {
    const onClickHandler = props.innerProps.onClick;
    return (react_1.default.createElement("div", { onTouchEnd: (e) => {
            e.preventDefault();
            onClickHandler(e);
        } },
        react_1.default.createElement(react_select_1.components.Option, Object.assign({}, props))));
};
const SingleSelect = (props) => {
    const { 'aria-label': ariaLabel, defaultOption, onChangeHook, options, selectKey, isSearchable, id, defaultMenuPlacement = 'auto' } = props;
    const [selectRegistryState, selectRegistryActions] = (0, monera_app_core_1.useSelectStore)();
    const [menuPosition, setMenuPlacement] = (0, react_1.useState)(defaultMenuPlacement);
    (0, react_1.useEffect)(() => {
        const keyToOption = {
            [selectKey]: defaultOption
        };
        selectRegistryActions.update(keyToOption);
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', handleMenuPlacement);
        handleMenuPlacement();
        return () => window.removeEventListener('resize', handleMenuPlacement);
    }, []);
    const onChange = (item) => {
        const option = item;
        const keyToOption = {
            [selectKey]: option
        };
        selectRegistryActions.update(keyToOption);
        if (onChangeHook) {
            onChangeHook(option);
        }
    };
    const handleMenuPlacement = () => {
        if (id && defaultMenuPlacement === 'auto') {
            const windowHeight = window.innerHeight;
            const selectElement = document.getElementById(id);
            const selectOffSetBottom = selectElement ? selectElement === null || selectElement === void 0 ? void 0 : selectElement.getBoundingClientRect().bottom : 0;
            const optionHeight = props.optionHeight ? parseInt(props.optionHeight) : 36;
            const menuHeight = Math.min(optionHeight * options.length, 300);
            if (windowHeight - selectOffSetBottom > menuHeight) {
                setMenuPlacement('bottom');
            }
            else {
                setMenuPlacement('top');
            }
        }
    };
    return (react_1.default.createElement(react_select_1.default, { id: id, menuPlacement: menuPosition, "aria-label": ariaLabel, options: options, styles: parseCustomStyles(props), value: selectRegistryState[selectKey], isSearchable: isSearchable, components: { Control: CustomControl, DropdownIndicator: CustomIndicator, Option: CustomOption }, onChange: onChange }));
};
exports.SingleSelect = SingleSelect;
